import clsx from 'clsx'
import { mailboxApi, MailboxUI } from 'features/messaging'
import { memo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAppSelector } from 'shared/hooks'
import typo from 'shared/styles/typography.module.scss'

import { appSelectors } from '../../../redux/reducers/app'
import css from './NavigationMenu.module.scss'

interface LinkItem {
	href: string
	isCurrent: (pathname: string) => boolean
	label: string
}

const createLink = (
	href: string,
	label: string,
	isCurrent = (pathname: string) => pathname.startsWith(href)
): LinkItem => ({
	href,
	isCurrent,
	label
})

const links: LinkItem[] = [
	createLink(
		'/campaigns',
		'Campaigns',
		pathname =>
			pathname.startsWith('/campaigns') || pathname.startsWith('/archive')
	),
	createLink('/contacts', 'Contacts'),
	createLink('/team/members', 'Team', pathname => pathname.startsWith('/team'))
]

const mailboxLink: LinkItem = createLink('/messaging', 'Messaging')

function NavigationMenu_() {
	const { pathname } = useLocation()

	const isBetaUser = useAppSelector(appSelectors.isBetaUser)
	const renderLinks = isBetaUser ? links.concat(mailboxLink) : links

	return (
		<nav>
			<ul className={css.list}>
				{renderLinks.map(({ href, isCurrent, label }) => {
					const isActive = isCurrent(pathname)

					return (
						<li key={href}>
							<Link
								aria-current={isActive ? 'page' : undefined}
								className={clsx(
									typo[isActive ? 'buttonSmB' : 'buttonSm'],
									css.link,
									isActive && css.active
								)}
								to={href}
							>
								{label}

								{href === '/messaging' && <UnreadCount />}
							</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

function UnreadCount() {
	const hasAutomatization = useAppSelector(appSelectors.hasAutomation)

	const isPulling = MailboxUI.useIsPulling()

	const { data } = mailboxApi.useUnreadQuery(
		undefined,
		isPulling
			? {
					...MailboxUI.PULLING_OPTIONS,
					skip: !hasAutomatization
				}
			: {
					skip: !hasAutomatization
				}
	)

	return <MailboxUI.UnreadCount {...data} />
}

export const NavigationMenu = memo(NavigationMenu_)
